import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { prepareData } from 'helpers/prepare-req-data'
import { prepParams } from 'helpers/prep-req-url'
import { getRespData  } from 'helpers/get-resp-data'
import client from 'api'
import _ from 'lodash'

import { v4 as uuid4 } from 'uuid'


const initialState = {
    startProcess1003Status: 'idle',
    startProcess1003Error: undefined as any,
    loadUserParamsProcess1003Status: 'idle',
    loadUserParamsProcess1003Error: undefined as any,

    process1003List: [] as any[],
    defaultValues: undefined as any,
    job: undefined as any,
    filterValues: {} as any,
    filterLookupValues: {} as any,

    directLoad: false,
    load: false,
    activeDivRef: null as any,

    filterValuesId: null,
    valuesFromDB: false,
    filterVisibleId: null,
    filterVisible: true,
}


export const startProcess1003 = createAsyncThunk('process1003Slice/startProcess1003', async ({ process1003 }: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.post(
        `/api/ixweb/StartProcess1003/`,
        prepareData(process1003),
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { startProcess1003Status } = getState().process1003Slice
        return startProcess1003Status !== 'pending'
    }
})

export const loadUserParamsProcess1003 = createAsyncThunk('process1003Slice/loadUserParamsProcess1003', async (_: any, { rejectWithValue }: any) => {
    let promises = []
    promises.push(client.get(
        `/api/ixweb/LoadUserParamsProcess1003/`,
    ))

    const [value1Res] = await Promise.all(promises)
    const value1 = getRespData(value1Res, rejectWithValue)

    return {
        data: value1.map((x: any) => ({
            ...x,
        })),
    }
}, {
    condition: ({}: any, { getState }: any) => {
        const { loadUserParamsProcess1003Status } = getState().process1003Slice
        return loadUserParamsProcess1003Status !== 'pending'
    }
})

const Process1003Slice = createSlice({
    name: 'process1003Slice',
    initialState,
    reducers: {
        resetstartProcess1003: (state) => {
            state.job = undefined
            state.startProcess1003Error = undefined
        },
        resetstartProcess1003Error: (state) => {
            state.startProcess1003Error = undefined
        },
        resetloadUserParamsProcess1003: (state) => {
            state.defaultValues = undefined
            state.loadUserParamsProcess1003Error = undefined
        },
        resetloadUserParamsProcess1003Error: (state) => {
            state.loadUserParamsProcess1003Error = undefined
        },
        removeFromProcess1003ListById: (state, action) => {
            state.process1003List = state.process1003List.filter((x: any) => x.HDR_ID !== action.payload)
        },
        removeFromProcess1003ListByIds: (state, action) => {
            state.process1003List = state.process1003List.filter((x: any) => action.payload.indexOf(x.HDR_ID) === -1)
        },
        setFilterValues: (state, action) => {
            if (action.payload === undefined || action.payload === null) {
                state.filterValues = {}
            } else {
                state.filterValues = { ...state.filterValues, ...action.payload }
            }
        },
        setFilterLookupValue: (state, action) => {
            const { name, value, formValue } = action.payload
            if (name) {
                state.filterLookupValues[name] = value
                state.filterValues[name] = formValue
            }
        },
        setDirectLoad: (state, action) => { state.directLoad = action.payload },
        setLoad: (state, action) => { state.load = action.payload },
        setActiveDivRef: (state, action) => { state.activeDivRef = action.payload},
        setFilterValuesId: (state, action) => {
            state.filterValuesId = action.payload
        },
        setValuesFromDB: (state, action) => {
            state.valuesFromDB = action.payload
        },
        setFilterVisibleId: (state, action) => {
            state.filterVisibleId = action.payload
        },
        setFilterVisible: (state, action) => {
            state.filterVisible = action.payload
        },
        preloadData: (state, action) => {
            state.process1003List = action.payload.map((x: any) => ({ ...x, HDR_ID: uuid4()}))
            state.startProcess1003Status = 'preloaded'
        },
        clearPreloadedData: (state) => {
            state.process1003List = []
            state.startProcess1003Status = 'idle'
        },
    },
    extraReducers: builder => {
        builder.addCase(startProcess1003.pending, (state) => {
            state.startProcess1003Status = 'pending'
            state.startProcess1003Error = undefined
        })
        builder.addCase(startProcess1003.fulfilled, (state, action) => {
            state.startProcess1003Status = 'idle'

            {
                state.job = action.payload

            }
        })
        builder.addCase(startProcess1003.rejected, (state, action) => {
            state.startProcess1003Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.startProcess1003Error = action.error.message
            } else {
                state.startProcess1003Error = action.payload
            }
        })

        builder.addCase(loadUserParamsProcess1003.pending, (state) => {
            state.loadUserParamsProcess1003Status = 'pending'
            state.loadUserParamsProcess1003Error = undefined
        })
        builder.addCase(loadUserParamsProcess1003.fulfilled, (state, action) => {
            state.loadUserParamsProcess1003Status = 'idle'

            {
                state.defaultValues = action.payload

            }
        })
        builder.addCase(loadUserParamsProcess1003.rejected, (state, action) => {
            state.loadUserParamsProcess1003Status = 'error'
            if (action.error.message !== 'Rejected') {
                state.loadUserParamsProcess1003Error = action.error.message
            } else {
                state.loadUserParamsProcess1003Error = action.payload
            }
        })

    }
})

export const {
    resetstartProcess1003,
    resetstartProcess1003Error,
    resetloadUserParamsProcess1003,
    resetloadUserParamsProcess1003Error,
    removeFromProcess1003ListById,
    removeFromProcess1003ListByIds,
    setFilterValues,
    setFilterLookupValue,
    setDirectLoad,
    setLoad,
    setActiveDivRef,
    setFilterValuesId,
    setValuesFromDB,
    setFilterVisible,
    setFilterVisibleId,
    preloadData,
    clearPreloadedData,
} = Process1003Slice.actions
export default Process1003Slice.reducer
